import React from "react";
import { Link } from "react-router-dom";
import TabsLayoutHeading from "components/dashboard/common/TabsLayoutHeading/TabsLayoutHeading";
// import PaginationSearch from "components/ui/InputTypes/InputSearch/PaginationSearch/PaginationSearch";
import FormsPostFormBranchesHeaderButton from "./FormsPostFormBranchesHeaderButton/FormsPostFormBranchesHeaderButton";
import FormAccessControl from "../../Forms/FormAccessControl";
import "./FormsPostFormBranchesHeader.scss";
import Filter from "components/dashboard/common/Filter/Filter";

const FormsPostFormBranchesHeader = ({
    handleSearch,
    searchIsLoading,
    clearSearch,
    handleSortByAlpha,
    handleSortByDate,
    handleSortByLastModified,
    baseFilter,
    filterOption,
    handleBasefilter,searchDefaultValue
}) => {
    return (
        <div>
            <TabsLayoutHeading
                title={`Forms`}
                subTitle={`Add & change forms`}
                extraClass={"large"}
            />

            <div className='form-post-form-header'>
                <div className='row align-items-center'>
                    {/* <PaginationSearch
                        handleSearch={handleSearch}
                        placeholder='Search forms here'
                        isLoading={searchIsLoading}
                        clearSearch={clearSearch}
                    /> */}
                </div>
                <div>
                    <FormAccessControl action='update'>
                        <Link to={`/knowledge-base/form/new`}>
                            <FormsPostFormBranchesHeaderButton />
                        </Link>
                    </FormAccessControl>
                </div>
            </div>
            <Filter
                handleSortByAlpha={handleSortByAlpha}
                handleSortByDate={handleSortByDate}
                handleSearch={handleSearch}
                handleSortByLastModified={handleSortByLastModified}
                searchPlaceholder='Search forms here'
                searchIsLoading={searchIsLoading}
                clearSearch={clearSearch}
                hideClassFilter
                baseFilter={baseFilter}
                filterOption={filterOption}
                handleBasefilter={handleBasefilter}searchDefaultValue={searchDefaultValue}
            />
        </div>
    );
};

export default FormsPostFormBranchesHeader;
